<!--aggiugere :label="getLabel(result)" nel map-marker per mostrare il numero di corsi presenti sul marker-->
<template>
<div 
    v-show="show"
    class="search-view-map"
>
    <google-map 
        ref="mapRef"
        :center="mapCenter"
        map-type-id="terrain"
        :options="mapOptions"
        :style="{width: '100%', height: '100%'}"
    >
        <google-map-cluster
            :grid-size="50"
            :minimum-cluster-size="10"
            :max-zoom="10"
            :zoom-on-click="true"
        >
            <google-map-marker
                :key="index"
                :ref="'marker-' + index"
                v-for="(result, index) in results"
                :position="getPosition(result)"
                :clickable="true"
                icon="/images/map/map_marker.svg"
                @click="showCourseInfo(index, $event)">
            </google-map-marker>
        </google-map-cluster>
    </google-map>
</div>
</template>
<script>
    import {gmapApi} from 'vue2-google-maps'
    import GoogleMapCluster from 'vue2-google-maps/dist/components/cluster'
    import SearchResultCard from '../results/ResultMapCourseCard'

    export default {
        name: 'SearchViewMap',
        props: {
            resultsprop: {
                type: Array,
                default() {
                    return []
                }
            },
            show: {
                type: Boolean,
                default: false
            }
        },
        components: {GoogleMapCluster},
        data() {
            return {
                params: {
                    age: '',
                    days: [],
                    disabilities: [],
                    startTime: '',
                    municipality: ''
                },
                results: this.resultsprop,
                map: null,
                infoWindow: null,
                apply_municipality_strict : true,
                mapOptions:{
                    zoom: 10,
                    disableDefaultUI : true,
                    zoomControl: true,
                    fullscreenControl: true
                },
            }
        },
        computed: {
            google: gmapApi,
            mapCenter() {
                let lat = this.getParameterByName('latitude') * 1
                let lng = this.getParameterByName('longitude') * 1
                if (_.isNumber(lat)) {
                    return {
                        lat: lat * 1,
                        lng: lng * 1
                    }
                }

                if (_.isEmpty(this.resultsprop)) {
                    return  { lat: 0, lng: 0 }
                }

                if (this.resultsprop.length > 0) {
                    return {
                        lat: _.head(this.resultsprop).latitude * 1,
                        lng: _.head(this.resultsprop).longitude * 1
                    }
                }
            }
        },
        watch: {
            show(val) {
                let view = this.getParameterByName('view')

                if (val) {
                    if (!_.isEmpty(view)) {
                        this.onInitMapFirst()
                    } else {
                        this.onInitMapOnShow()
                    }
                }
            }
        },
        mounted() {
            this.params = Object.assign(this.params, {
                municipality: this.getParameterByName('municipality'),
                search_string: this.getParameterByName('search_string')
            })

            this.$bus.$on('map-filters', ({filters, search_string}) => {
                this.params = Object.assign(this.params, filters);
                this.params = Object.assign(this.params, {search_string});
                this.fitBounds()
            })
        },
        methods: {
            onInitMapOnShow() {
                let vm = this
                let map = this.$refs.mapRef;
                this.$set(this, 'map', map)

                this.fitBounds();
                this.map.$mapObject.addListener('idle', _.debounce(() => {
                    if (! _.isNull(vm.infoWindow)) {
                        return
                    }

                    let bounds = vm.map.$mapObject.getBounds()
                    let coordinates = {
                        sup: {lat: bounds.getNorthEast().lat(), lng: bounds.getNorthEast().lng()},
                        inf: {lat: bounds.getSouthWest().lat(), lng: bounds.getSouthWest().lng()}
                    }

                    vm.$set(vm, 'params', Object.assign(vm.params, coordinates))
                    vm.updateResults()
                }, 500))
            },
            onInitMapFirst() {
                let vm = this

                this.$refs.mapRef.$mapPromise.then((map) => {
                    this.$set(this, 'map', map)

                    this.fitBounds();
                    map.addListener('idle', _.debounce(() => {
                        if (! _.isNull(vm.infoWindow)) {
                            return
                        }

                        let bounds = map.getBounds()
                        let coordinates = {
                            sup: {lat: bounds.getNorthEast().lat(), lng: bounds.getNorthEast().lng()},
                            inf: {lat: bounds.getSouthWest().lat(), lng: bounds.getSouthWest().lng()}
                        }

                        vm.$set(vm, 'params', Object.assign(vm.params, coordinates))
                        vm.updateResults()
                    }, 500))
                })
            },
            getParameterByName(name, url) {
                if (!url) url = window.location.href;

                name = name.replace(/[\[\]]/g, '\\$&');
                var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
                    results = regex.exec(url);

                if (!results) return null;
                if (!results[2]) return '';

                return decodeURIComponent(results[2].replace(/\+/g, ' '));
            },
            updateResults() {
                axios.get('/filterMapCourses', {
                    params: {
                        filters: this.params,
                        search_string: this.getParameterByName('search_string'),
                        // apply_municipality_strict: this.apply_municipality_strict
                        apply_municipality_strict: this.apply_municipality_strict
                    }
                }).then((response) => {
                    this.results = response.data;
                    this.apply_municipality_strict = false;
                }).catch((error) => {
                    this.$bus.$emit('filtered', null);
                    window.alerts.error("Si è verificato un errore con la tua ricerca");
                });
            },
            fitBounds() {
                let self = this;
                this.$refs.mapRef.$mapPromise.then((map) => {
                    if (!_.isEmpty(self.results)) {
                        let bounds = new self.google.maps.LatLngBounds();
                        self.results.forEach(function (result) {
                            bounds.extend(self.getPosition(result));
                        });
                        map.fitBounds(bounds);
                    }
                    else {

                        let lat = this.getParameterByName('latitude') * 1
                        let lng = this.getParameterByName('longitude') * 1
                        if (_.isNumber(lat)) {
                            let initialLocation = new self.google.maps.LatLng(lat, lng);
                            map.setCenter(initialLocation);
                            map.setZoom(15);
                        } else if (navigator.geolocation) {
                            navigator.geolocation.getCurrentPosition(position => {
                                let initialLocation = new self.google.maps.LatLng(position.coords.latitude, position.coords.longitude);
                                map.setCenter(initialLocation);
                                map.setZoom(15);
                            });
                        }
                    }
                })
            },
            getPosition(result) {
                return {lat: result.latitude * 1, lng: result.longitude * 1}
            },
            getLabel(course) {
                let self = this;
                var num_course = 0;
                var label = {
                    text: "",
                    color: "#4a4a4a",
                    fontSize: "10px",
                }
                this.results.forEach(function (result) {
                    if (course.latitude === result.latitude && course.longitude === result.longitude) {
                        num_course = parseInt(num_course) + 1;
                    }
                });
                label.text = String(num_course);
                return label;
            },
            showCourseInfo(index, ev) {
                const CardComponent = Vue.extend(SearchResultCard);
                var course = this.results[index];
                var actualCourses = [];
                var cards = [];
                var html = "";
                if (this.infoWindow) {
                    this.infoWindow.close();
                }
                this.results.forEach(function (item) {
                    if (course.latitude === item.latitude && course.longitude === item.longitude) {
                        actualCourses.push(item);
                    }
                });
                actualCourses.forEach(function (item) {
                    var cardInstance = new CardComponent({
                        propsData: {
                            course: item,
                            insideMap: true
                        }
                    });
                    cardInstance.$mount();
                    cards.push(cardInstance);
                });
                cards.forEach(function (item) {
                    html += item.$el.outerHTML;
                });
                this.infoWindow = new this.google.maps.InfoWindow({
                    content: `<div class="results-info-window">${html}</div>`
                });
                const marker = this.$refs[`marker-${index}`][0].$markerObject
                this.infoWindow.open(this.map, marker);

                this.google.maps.event.addListener(this.infoWindow, 'domready', () => {
                    const iwElements = document.getElementsByClassName("gm-style-iw")
                    for (const el of iwElements) {
                        el.style.top = '20px';
                        let children = el.previousSibling.children
                        children[1].style.display = 'none'
                        children[3].style.display = 'none'

                        let closeBtn = el.nextSibling
                        closeBtn.style.marginRight = '35px'
                        closeBtn.style.marginTop = '16px'
                    }
                });
                this.google.maps.event.addListener(this.infoWindow, 'closeclick', () => {
                    this.$set(this, 'infoWindow', null)
                    this.fitBounds()
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/search/SearchViewMap.vue